import React from 'react'
import './Nindhi.scss'
import FirstImage from '../../images/nindhi/First.png'
import { Navbar } from '../../components/Navbar/Navbar'
import Group1 from '../../images/nindhi/Group1.png'
import OneDayBefore from '../../images/nindhi/OneDayBefore.png'
import SS from '../../images/nindhi/SS.png';


export const Nindhi = () => {
  return (
    <>
      <Navbar />
      <div className="nindhi-main-div">
        <div className="where-it-all-started-section">
          <img src={FirstImage} className="main-image" />
          <div className="heading">Where It All Started</div>
        </div>

        <div className="story-part">
          Once upon a time, there was a princess named{' '}
          <span className="color">Arushi Gandhi </span> , who was born in a
          Jain/Marwari home, yes, the ones who believe in god like nothing else
          and also hate the smell of eggs (except on some people). She was
          considered to be one of the greatest creations of the Marwari gods,
          and the whole town was in love with her beauty. She was active in
          helping out people who were not as privileged as her, and this added
          more to her beauty.{' '}
          <span className="bold">Plus her smile, Jesus Christ.</span>
        </div>
        <div className="story-part">
          In the same town, there was another dude named{' '}
          <span className="color">Aryamann Ningombam</span>, who was born and
          brought up by a rich fam, and this gandu was considered to be one of
          the, if not the most arrogant guy the town had ever seen. He was
          smart, but the problem was that he knew he was smart, so he acted that
          way most of the times.{' '}
          <span className="bold">
            Cold, arrogant, silent, never smiling, all of these words defined
            him. Or did they?
          </span>
        </div>

        <div className="story-part">
          The first time they had met each other, was when Aryamann was
          exploring the town with his friends, and Arushi was preaching about
          feminism and women empowerment, to the audience. Their eyes didn’t
          meet, but they were aware of the presence of the other person,
          although trying to not pay much attention to it. They were near, but
          still far from each other. Arushi talked to almost everyone in the
          room except Mr. Aryamann, because of what she had heard and the little
          she had seen him, she didn’t have the best impression. She saw him as
          nothing but just another arrogant guy who was a capitalist, jesus
          christ, that is a big deal sometimes.
        </div>
        <div className="quote">
          "I don't like Aryamann" <div className="color"> - Arushi Gandhi</div>
        </div>

        <div className="quote">
          "“She’s a socialist and feminist bro, jesus"{' '}
          <div className="color"> - Aryamann Ningombam</div>
        </div>

        <div className="story-part">
          They never intended to meet each other, but somehow always did,
          because of a common companion. Arushi was the fun loving type, who
          hung out with the cool dudes and girls, on the other spectrum,
          Aryamann hung out with the geeks and the nerds out of all people. He
          was a hard worker, and everyone knew it. On top of that, he was
          hyper-competitive, jesus, that’s hard to handle when you’re dating.
          They soon began to talk, but their impressions about each other still
          remained the same, so they only conversed if it was absolutely needed.
          So, when did it all change?
        </div>
        <div className="group-1-image">
          <img src={Group1} alt="" className="main-image" />
        </div>

        <div className="quote">
          "He's like Damon" <div className="color"> - Arushi Gandhi</div>
        </div>

        <div className="quote">
          "She thinks different, I just wanna know why, just talk."{' '}
          <div className="color"> - Aryamann Ningombam</div>
        </div>

        <div className="story-part">
          Well, how tf in this world would these two personalities ever meet,
          just one reason, they both were hot asf ( jk, only the guy was ). It
          was mostly because of a common friend (who’s birthday is coming up
          btw, bhul mat jana Aryamann). This common friend basically was in a
          bad phase, and they both helped her get through it. But obviously, one
          didn’t like the approach of the other. The guy was objective about
          everything, only giving the friend advice that was practical, and 0
          emotions, while the princess was more emotional than objective. But
          nvt, they both cared for the common friend, and because of that, they
          started talking to each other. Well, what can you say, Arushi then
          fell for Aryamann, and then they joined the mile-high club. That is
          obviously not what happened, because there were no planes at that
          time, but if there were, then it woud’ve happened.
        </div>

        <div className="story-part">
          Things started to change in the neighbourhood, there was a new disease
          that was spreading, and it was spreading fast. It was spreading in a
          lot more places, but the exponential increase of people getting hit
          with the disease was a lot more where these two lived. Everyone
          started to move out of the town, and move to safer places where people
          were not getting as dead as here, F. Arushi and Aryamann, trying to be
          studs, didn’t want to leave, because they loved their town, but
          circumstances made them doubt their decisions. When they saw that the
          disease was started to get a little too close to them, they decided to
          bounce. Interestingly, for some reason, they had a common stop, and
          they decided ( the dude did, he was so hot that the girl coudn’t just
          say no ) to go to the common destination together. They packed their
          bags ( potli in desi bhasha ), and travelled with their bullock cart.
          They spent the whole day together, and then the spark came. (imma be
          honest now, im tired of writing this)
        </div>

        <div className="story-part">
          They did nothing kinky, although they should have, but they saw a
          completely different version of what they had in mind of the other
          person. They talked the whole day (Aryamann did actually, Arushi was
          just smiling and trying to get to the destination asap). They ate
          together, Aryamann wanted to make her try meat for dinner, but
          unfortunately, they journey ended before that time, and both had to
          part their ways. This was one of the first times Mr. Aryamann, the
          cold guy who had drifted away from more people than most ever meet,
          actually felt sad that the day had ended, and what about ArushI? I
          have not fucking clue, maybe she was relieved, maybe sad. But that day
          was different, a lot better than what they had expected, but the sad
          that was that they didn’t join the mile-high club.
        </div>

        <div className="group-1-image">
          <img src={OneDayBefore} alt="" className="main-image" />
        </div>

        <div className="story-part">
          The day after that, the dude got drunk, and it 4:35 a.m. right now, so
          I can’t write more of this anymore, so by goodnight, ILU.
        </div>

        <div className="group-1-image">
          <img src={SS} alt="" className="main-image" />
        </div>
      </div>
    </>
  )
}
